<template>

  <div class="custom-tree-container">
    <div class="block_l">
      <el-tree :data="menulist"
               node-key="id"
               :props="defaultProps"
               default-expand-all
               :expand-on-click-node="false"
               :render-content="renderContent">
      </el-tree>
    </div>
    <div class="block">
      <el-card class="box-card">
        <el-form :model="addform"
                 :rules="rules"
                 ref="addformRef"
                 size="mini">

          <el-form-item label="菜单名称"
                        prop="menuTitle"
                        :label-width="formLabelWidth">
            <el-input v-model="addform.menuTitle"
                      autocomplete="off"
                      style="width:50%"></el-input>
          </el-form-item>

          <el-form-item label="名称(英)"
                        prop="menuTitleEn"
                        :label-width="formLabelWidth">
            <el-input v-model="addform.menuTitleEn"
                      autocomplete="off"
                      style="width:50%"></el-input>
          </el-form-item>

          <el-form-item label="路由地址"
                        prop="menuRoute"
                        :label-width="formLabelWidth">
            <el-input v-model="addform.menuRoute"
                      autocomplete="off"
                      style="width:50%"></el-input>
          </el-form-item>

          <el-form-item label="路由名称"
                        prop="routeName"
                        :label-width="formLabelWidth">
            <el-input v-model="addform.routeName"
                      placeholder
                      style="width:50%"></el-input>
          </el-form-item>

          <el-form-item label="图标"
                        prop="menuIcon"
                        :label-width="formLabelWidth">
            <el-input v-model="addform.menuIcon"
                      autocomplete="off"
                      style="width:50%"></el-input>
          </el-form-item>

          <el-form-item label="是否文件夹"
                        prop="floder"
                        :label-width="formLabelWidth">
            <template>
              <el-radio v-model="addform.floder"
                        label="T">是</el-radio>
              <el-radio v-model="addform.floder"
                        label="F">否</el-radio>
            </template>
          </el-form-item>

          <el-form-item label="是否显示"
                        prop="showFlag"
                        :label-width="formLabelWidth">
            <template>
              <el-radio v-model="addform.showFlag"
                        label="T">是</el-radio>
              <el-radio v-model="addform.showFlag"
                        label="F">否</el-radio>
            </template>
          </el-form-item>
          <el-form-item label="父级菜单"
                        prop="parentId"
                        :label-width="formLabelWidth"
                        v-model="addform.parentId">
            <wlTreeSelect width="240"
                          :props="props"
                          :data="parentMenulist"
                          @change="hindleChanged"
                          collapseTags
                          v-model="addform.parentId"></wlTreeSelect>

          </el-form-item>

          <el-form-item label="权限类型"
                        prop="roleType"
                        :label-width="formLabelWidth">
            <el-select v-model="addform.roleType"
                       :collapse-tags='true'
                       placeholder="权限类型"
                       style="width:50%">
              <el-option v-for="item in roleTypes"
                         :key="item.id"
                         :label="item.label"
                         :value="item.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="排序"
                        prop="order"
                        :label-width="formLabelWidth">
            <el-input v-model="addform.order"
                      autocomplete="off"
                      style="width:50%"></el-input>
          </el-form-item>

          <el-row>
            <el-divider>操作 <el-button plain
                         type="primary"
                         @click="addItem()">添 加</el-button>
            </el-divider>
          </el-row>

          <el-row class="row-box"
                  v-for="(item, index) in addform.menu_actions"
                  :key="item.key">
            <el-col :span="5">
              <el-form-item label="名称"
                            label-width="50px">
                <el-input v-model="item.actionName"
                          placeholder
                          style="width:80px"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="名称(英)"
                            label-width="70px">
                <el-input v-model="item.actionNameEn"
                          placeholder
                          style="width:80px"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="5">
              <el-form-item label="路由"
                            label-width="50px">
                <el-input v-model="item.actionRoute"
                          placeholder
                          style="width:90px"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="角色"
                            label-width="50px">
                <el-select v-model="item.roleType"
                           :collapse-tags='true'
                           placeholder="角色">
                  <el-option v-for="item in roleTypes"
                             :key="item.id"
                             :label="item.label"
                             :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="3">
              <el-form-item :label-position="labelPosition">
                <el-button @click="deleteItem(index)"
                           class="delete-item"
                           type="text">删 除</el-button>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item>
            <el-button type="reset"
                       @click="resetForm('addformRef')">重 置</el-button>
            <el-button type="primary"
                       @click="addMenu">保 存</el-button>
            <el-input type="hidden"
                      v-model="addform.id"></el-input>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import wl from 'wl-vue-select'
import 'wl-vue-select/lib/wl-vue-select.css'
Vue.use(wl)

let id = 1000
export default {
  data() {
    return {
      defaultProps: {
        label: 'menuTitle',
        children: 'children',
        value: 'id',
      },
      props: {
        // 配置项（必选）
        label: 'menuTitle',
        children: 'children',
        value: 'id',
        // disabled:true
      }, //
      treeData: '',
      treeDataValue: '',
      addform: {
        id: '',
        menuTitle: '',
        menuRoute: '',
        menuIcon: '',
        floder: 'F',
        showFlag: 'T',
        parentId: '',
        menu_actions: [
          {
            key: 1,
            actionName: '',
            actionRoute: '',
            actionNameEn: '',
            roles: [],
          },
        ],
        order: '',
        roleType: '',
        routeName: '',
        permission: '',
      },
      rules: {
        menuTitle: [
          { required: true, message: '请输入菜单名称', trigger: 'blur' },
          {
            min: 2,
            max: 30,
            message: '长度在 2 到 20 个字符',
            trigger: 'blur',
          },
        ],
        menuTitleEn: [
          { required: true, message: '请输入菜单名称', trigger: 'blur' },
          {
            min: 2,
            max: 30,
            message: '长度在 2 到 20 个字符',
            trigger: 'blur',
          },
        ],
        menuRoute: [
          { required: true, message: '请输入路由地址', trigger: 'blur' },
        ],
        menuIcon: [
          {
            min: 2,
            max: 30,
            message: '图标长度在 2 到 20 个字符',
            trigger: 'blur',
          },
        ],
        parentId: [
          { required: true, message: '请选择父级菜单', trigger: 'change' },
        ],
      },
      menulist: [],
      parentMenulist: [
        {
          id: 0,
          menuTitle: 'Root',
          menuTitleEn: 'root',
          parentId: 0,
        },
      ],
      PermList: [],
      roleTypes: [
        { id: '0', label: 'admin' },
        { id: '1', label: '商家管理员' },
        { id: '2', label: '店铺管理员' },
        { id: '3', label: '系统操作员' },
      ],
      formLabelWidth: '100px',
      dialogFormVisible: false,
      labelPosition: 'right',
    }
  },

  methods: {
    hindleChanged(val) {
      typeof this.addform.parentId === 'object' &&
      this.addform.parentId.length > 0
        ? (this.addform.parentId = this.addform.parentId[0].id)
        : false
      this.addform.parentId === 0 ? (this.addform.parentId = '0') : false
    },
    append(data) {
      console.log(data)
      this.addform = Object.assign({}, data)
      data.parentId === 0 ? (this.addform.parentId = '0') : false
    },
    addItem() {
      this.addform.menu_actions.push({
        actionName: '',
        actionRoute: '',
        key: Date.now(),
        actionNameEn: '',
        roles: [],
      })
    },
    deleteItem(index) {
      this.addform.menu_actions.splice(index, 1)
    },
    // 删除
    remove(node, data) {
      const parent = node.parent
      const children = parent.data.children || parent.data
      const index = children.findIndex((d) => d.id === data.id)
      children.splice(index, 1)
    },

    renderContent(h, { node, data, store }) {
      return (
        <span class="custom-tree-node">
          <span>
            {node.label} <a href="javascript:void(0)">{data.menuRoute}</a>
          </span>
          <span>
            <el-button
              size="mini"
              type="text"
              on-click={() => this.append(data)}
            >
              <i class="el-icon-edit"></i>
            </el-button>
            <el-button
              size="mini"
              type="text"
              on-click={() => this.remove(node, data)}
            >
              <i class="el-icon-delete"></i>
            </el-button>
          </span>
        </span>
      )
    },
    // 新增菜单
    addMenu() {
      this.$refs.addformRef.validate(async (valid) => {
        if (!valid) return
        this.addform.parentId === '0' ? (this.addform.parentId = 0) : false
        await this.$http
          .post('addmenu', this.addform)
          .then((response) => {
            this.$message.success(response.data.meta.msg)
            this.dialogFormVisible = false
            this.getMenuList()
            this.resetForm('addformRef')
          })
          .catch((error) => {
            return this.$message.error(error.response.data.message)
          })
        this.addform.parentId === 0 ? (this.addform.parentId = '0') : false
      })
    },
    // 获取所有的菜单
    async getMenuList() {
      const { data: res } = await this.$http.post('menus', { type: 'all' })

      if (res.meta.status !== 200) return console.log(res.meta.msg)

      this.menulist = JSON.parse(JSON.stringify(res.data))
      this.$set(
        this.parentMenulist[0],
        'children',
        JSON.parse(JSON.stringify(res.data))
      )
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.addform.id = ''
      this.addform.menu_actions = []
      this.addform.children = []
    },
  },
  // 页面加载前
  created() {
    this.getMenuList()
  },
}
</script>

<style lang="less" scoped>
.custom-tree-container {
  max-height: 700px;
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
.block_l {
  width: 35%;
  float: left;
  max-height: 650px;
  overflow-y: auto;
}
.block {
  width: 65%;
  float: left;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.form-card {
  margin-bottom: 15px;
}
.add-card {
  width: 50%;
}
.el-dialog {
  /* 表单页面居中，宽度50% ,legend颜色设置，legend圆角*/
  border: 2px solid #dcdfe6;
  text-align: center;
  border-radius: 8px;
  margin: 0 auto;
  width: 50%;
}
.tag-m {
  margin-right: 1px;
}

.row-box {
  margin: 10px 0;
  padding: 12px;
  border-radius: 15px;
  border: 1px dashed#77a2cf;
}
.row-box-group {
  border: 1px dashed #cf7777;
}
.add-button {
  clear: both;
}
.add-button .el-button {
  width: 100%;
}
.delete-item {
  color: red;
}
</style>


// WEBPACK FOOTER //
// src/views/sys/menus/index.vue